// extracted by mini-css-extract-plugin
export default {"hgroup":"Top_hgroup__JOJm-","main":"Top_main__fDkuL","inner":"Top_inner__d3+bu"};